import { observer } from 'mobx-react-lite';

import { Typography } from '@workspace/ui/components/Typography';

import { useGlobal } from '~/hooks/useGlobal';

import type { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';
import { Body } from './components/Body';

const CategoriesGrid1Brand = ({ category, priority }: BlockCommonProps) => {
  const { subcategory, name } = category;
  const { isMobile } = useGlobal();

  const TitleComponent = isMobile
    ? Typography.Header100Medium
    : Typography.Header400Medium;

  return (
    <div>
      <div className="desktop:mb-10 mb-4 flex flex-row items-end justify-between">
        <TitleComponent as="h3" className="m-0 text-graphic-regular-brand">
          {name}
        </TitleComponent>
        <ViewAllButton link="/shop" />
      </div>
      <Body items={subcategory} priority={priority} />
    </div>
  );
};

export default observer(CategoriesGrid1Brand);
